module.exports = __webpack_public_path__ + "media/ding.2b00e409.mp3";